export function isOverflown({
  clientWidth,
  clientHeight,
  scrollWidth,
  scrollHeight,
}: Element): boolean {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
}
